import generateDecagonUserAuth from 'shared/graphql/decagon/queries/generate-decagon-user-auth.gql';

// Fetches the server-signed (signature, epoch) pair used to enable Decagon
// Signature Authentication via window.duet.setUserIdAuth. Returns null when the
// HMAC secret isn't provisioned (lower envs return { signature: null, epoch: null })
// or the request fails, in which case the chat widget continues to operate unsigned.
export async function fetchDecagonUserAuth(apolloClient) {
  try {
    const { data } = await apolloClient.query({
      query: generateDecagonUserAuth,
      fetchPolicy: 'network-only',
    });
    return data?.generateDecagonUserAuth ?? null;
  } catch (error) {
    console.error('Failed to fetch Decagon user auth signature', error);
    return null;
  }
}
